import type { ClientPollDeleteRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { POST_MUTATION_KEYS } from '@/features/api/constants/mutation';
import { useGrapevinePollEventsApi } from '@/features/api/hooks/grapevine-poll-events/useGrapevinePollEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForChangedPost } from '@/features/api/utils/postCaches';

export const usePollDelete = () => {
  const queryClient = useQueryClient();
  const api = useGrapevinePollEventsApi();

  return useApiMutation({
    mutationKey: [POST_MUTATION_KEYS.POLL],
    mutationFn: (clientPollDeleteRequest: ClientPollDeleteRequest) =>
      api.onPollDeleteRequest({ clientPollDeleteRequest }),
    onSuccess: ({ post }) =>
      invalidatePostCachesForChangedPost(queryClient, post)
  });
};
